import React from "react";
import "../stiluri/MeniuLateralRapoarte.css";


const MeniuLateralRapoarte = ({ onSectiuneSelectata }) => {
  return (
    <nav className="meniu-lateral-rapoarte">
      <h3>Statistici</h3>
      <ul>
        <li onClick={() => onSectiuneSelectata("privireGenerala")}>

          Privire Generală
        </li>
         <li onClick={() => onSectiuneSelectata("social")}>

          Sociale
        </li>
        <li onClick={() => onSectiuneSelectata("financiar")}>

          Financiare
        </li>
               <li onClick={() => onSectiuneSelectata("heatmap")}>

          Heatmap
        </li>
      </ul>
    </nav>
  );
};

export default MeniuLateralRapoarte;
